import { render, staticRenderFns } from "./LatestBookings.vue?vue&type=template&id=196d9f78&scoped=true"
import script from "./LatestBookings.vue?vue&type=script&lang=js"
export * from "./LatestBookings.vue?vue&type=script&lang=js"
import style0 from "./LatestBookings.vue?vue&type=style&index=0&id=196d9f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d9f78",
  null
  
)

export default component.exports